import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { AsyncPipe } from '@angular/common';
import { Component, HostBinding, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '@bcef/ia-components/buttons';
import { DatepickerModule } from '@bcef/ia-components/datepicker';
import { IbanInputModule } from '@bcef/ia-components/iban-input';
import { InputComponent } from '@bcef/ia-components/input';
import { ListboxModule } from '@bcef/ia-components/listbox';
import { PanelModule } from '@bcef/ia-components/panel';
import { RadioButtonModule } from '@bcef/ia-components/radio-button';
import { TooltipModule } from '@bcef/ia-components/tooltip';
import { IconsModule } from '@bcef/ia-ng-icons';
import { DataLayered } from '@difa/ia-data-layer';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskConfig, NgxMaskDirective, provideNgxMask } from 'ngx-mask';

import { Country } from '@features/succession/enums';
import { SuccessionFacade } from '@features/succession/succession.facade';
import { InvalidControlScrollDirective } from '@shared/directives/invalid-control-scroll.directive';

import { DeceasedInformationFacade } from './deceased-information.facade';

@DataLayered('dataLayer.deceasedInformation')
@Component({
  selector: 'ia-succession-deceased-information',
  templateUrl: './deceased-information.component.html',
  preserveWhitespaces: true,
  imports: [
    AsyncPipe,
    ButtonModule,
    DatepickerModule,
    IconsModule,
    InputComponent,
    ListboxModule,
    NgxMaskDirective,
    PanelModule,
    RadioButtonModule,
    ReactiveFormsModule,
    TooltipModule,
    TranslateModule,
    IbanInputModule,
    InvalidControlScrollDirective,
  ],
  standalone: true,
  providers: [provideNgxMask()],
})
export class DeceasedInformationComponent {
  @HostBinding('class') public classAttribute = 'tw-flex tw-flex-col tw-my-10 tw-mx-0 sm:tw-mx-24';

  public readonly successionFacade = inject(SuccessionFacade);

  public readonly deceasedInformationFacade = inject(DeceasedInformationFacade);

  public countryFrance: Country = Country.FRANCE;

  public numbersOnlyOrSpecialCharactersNotAllowed: NgxMaskConfig['patterns'] = {
    A: { pattern: new RegExp('[0-9]') },
    B: { pattern: new RegExp('[^:\'";()&<>*^\x00|]') },
  };

  protected listBoxOverlayConfig: OverlayConfig = {
    scrollStrategy: inject(Overlay).scrollStrategies.close(),
  };
}
